import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ListItem } from '../../../../models/api/core/list/list-item';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { BaseComponent } from '../../../base/base.component';
import { SelectOptionComponent } from './select-option.component';

@Component({
  selector: 'app-benefit-status-option',
  imports: [SelectOptionComponent],
  template: `
    <app-select-option
      label="The benefit status is"
      [control]="control"
      [showList]="true"
      [listControl]="listControl"
      [items]="filteredItems"
      [multiple]="true"
      [filter]="false"
      [listControlRequired]="true"
    />
  `,
  styles: ``,
})
export class BenefitStatusOptionComponent
  extends BaseComponent
  implements OnInit
{
  alerts = inject(AlertsService);

  @Input()
  listControl: FormControl<any>;

  @Input()
  control: FormControl<any[]>;

  @Input()
  lobControl: FormControl<string[]>;

  filteredItems: ListItem[] = [];

  private lobRestrictions = new Map<string, string>([
    ['WR', 'WC'],
  ]);

  async ngOnInit() {
    if (this.listControl.value == null) {
      this.listControl.setValue(
        this.alerts.find(this.alerts.listItems, 'InList'),
      );
    }

    this.control.setValidators([Validators.required]);
    if (this.control.value == null) {
      this.control.setValue([]);
    }

    this.filterItems();

    if (this.lobControl) {
      this.dispose.subs = this.lobControl.valueChanges.subscribe(() => {
        this.filterItems();
      });
    }
  }

  private filterItems() {
    const lobs = this.lobControl?.value ?? [];
    if (lobs.length === 0) {
      this.filteredItems = this.alerts.benefitStatus;
      return;
    }

    this.filteredItems = this.alerts.benefitStatus.filter((item) => {
      const restrictedTo = this.lobRestrictions.get(item.value);
      return !restrictedTo || lobs.includes(restrictedTo);
    });

    this.removeInvalidSelections();
  }

  private removeInvalidSelections() {
    const validValues = new Set(this.filteredItems.map((i) => i.value));
    const current = this.control.value;
    if (Array.isArray(current) && current.length > 0) {
      const filtered = current.filter((v) => {
        const val = typeof v === 'string' ? v : v.value;
        return validValues.has(val);
      });
      if (filtered.length !== current.length) {
        this.control.setValue(filtered);
      }
    }
  }
}